import React, { useState } from 'react'
import HeaderBack from './_HeaderBack'
import disalimentazione from '../../assets/img/disalimentazione.svg'
import axios from 'axios'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'

function Chiudere() {
    const navigate = useNavigate()
    const [checkBox, setCheck] = useState(false)
    const pod = useSelector((user) => user.user.info.pod_code)
    const customerId = useSelector((user) => user.user.info.customer_id)
    const costo = useSelector((user) => user.faidate.costi)
    const check = () => {
        if(!checkBox){
            alert('Devi accettare termini e condizioni')
        } else {
            const url = `https://my.revoluce.it/area_utente/gestione/api/faidate/chiusuraContatore.php?customer_id=${customerId}&codice_pod=${pod}`
            axios.get(url)
            navigate('/enrica/richiesta-inoltrata')
        }
    }
    return (
        <div className="faiDaTe_component">
            <HeaderBack text="Fai da te" step={0}/>
            <div className="icon">
                <img src={disalimentazione} alt="spostamento" />
            </div>
            <div className="body">
                <div className="paragraph">
                    <h1 className="h1">Disalimentazione</h1>
                    <p>Puoi scegliere di chiudere il tuo contatore cessando il contratto e interrompendo l’erogazione di energia elettrica verso la tua utenza.</p>
                </div>
                <div className="paragraph">
                    <h2 className="h2">Cosa si intende per disalimentazione del contatore?</h2>
                    <p>Nel momento in cui decidi che vuoi sospendere definitivamente l’erogazione di energia elettrica verso la tua utenza (devi quindi abbandonare l’appartamento e non hai più bisogno dell’energia) puoi disalimentare il contatore.</p>
                </div>
                <div className="paragraph box">
                    <h2 className="h2">Questa operazione non può essere momentanea.</h2>
                    <p>Nel momento in cui vorrai riattivare il contatore dovrai stipulare un nuovo contratto ed effettuare un subentro, per maggiori informazioni puoi approfondire <a href="https://revoluce.zendesk.com/hc/it/articles/360017592817-Hai-bisogno-di-fare-una-voltura-Ecco-come-farla-in-3-semplici-passi">cliccando qui</a></p>
                </div>
                <div className="paragraph">
                    <h2 className="h2">Tempi e Costi</h2>
                    <p><span className="bold">Tempo massimo di lavorazione:</span> 7 giorni lavorativi dalla richiesta del cliente.</p>
                    <p><span className="bold">Costo:</span> € {costo !== null ? costo : ''} IVA compresa. Il costo della disalimentazione del contatore verrà addebitato all’interno del primo Estratto Conto utile.</p>
                    <p>Quando decidi di chiudere il contatore automaticamente decidi di terminare il tuo contratto con Revoluce. Qualora un domani vorrai riattivare il contatore, il prezzo al kWh e l’eventuale canone fisso mensile non potranno in alcun modo rimanere gli stessi del vecchio contratto, ma bensì si andranno ad aggiornare secondo i prezzi in vigore in quel momento, in base al “Listino prezzi Revoluce in vigore oggi” che potrai trovare online.</p>
                </div>
                <div className="paragraph boxForm">
                    <h2 className="h2">Voglio chiudere il mio contatore</h2>
                    <div className="checkbox">
                        <input type="checkbox" onChange={() => setCheck(!checkBox)}/>
                        <p>Proseguendo con l’invio della richiesta dichiaro di aver letto ed accettato le tempistiche necessarie per il completamento dell’operazione e il preventivo di costo indicato.</p>
                    </div>
                    <div className="cta">   
                        <button onClick={() => check()}>Inoltra richiesta</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Chiudere
